export function fromJSONSerialization<T>(data: any): T {
    if (!data || typeof data !== "object") {
        return data as T; // Return primitive types or null/undefined as-is
    }

    // Recursively process each key in the object
    const result: any = Array.isArray(data)
        ? data.map((item) => fromJSONSerialization(item)) // Handle arrays recursively
        : Object.keys(data).reduce((acc: any, key) => { // Add index signature to 'acc' object
              const value = data[key];

              // Check if the value is a string and looks like a date
              if (typeof value === "string" && isISODateString(value)) {
                  const date = new Date(value);
                  acc[key] = isValidDate(date) ? date : null; // Convert to Date or null if invalid
              } else if (typeof value === "object" && value !== null) {
                  acc[key] = fromJSONSerialization(value); // Recursively process nested objects
              } else {
                  acc[key] = value; // Preserve other types as-is
              }

              return acc;
          }, {});

    return result as T;
}

// Helper function to check if a string is an ISO date
function isISODateString(value: string): boolean {
    // Basic check for ISO 8601 date format (e.g., "2024-12-03T10:00:00.000Z")
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value);
}

function isValidDate(date: Date): boolean {
    return date && typeof date.getTime === 'function' && !isNaN(date.getTime());
}